import {
	Message
} from 'element-ui'
import {
	getApproverDetailInfo,
	getFlowTemplate,
	getMediaId,
	getLastFlowTemplate
} from '@/api/approval'
//初始化组件
export function assignControl(controls, logInfo) {
	controls.TemplateContent.Controls.forEach(item => {
		if (item.Property.Title[0].Text == "部门") {
			item.Value = logInfo.DeptName;
		} else if (item.Property.Title[0].Text == "人员") {
			item.Value = logInfo.EmpName;
		}else if (item.Property.Title[0].Text == "姓名") {
			item.Value = logInfo.EmpName;
			item.Disable;
		}
		 else if (item.Property.Title[0].Text == "工号") {
			item.Value = logInfo.EmpNo;
		} else if (item.Property.Title[0].Text == "入职时间") {
			item.Value = logInfo.InCompanyDate;
		} else if (item.Property.Title[0].Text == "联系电话") {
			item.Value = logInfo.Mobile;
		} else if (item.Property.Title[0].Text == "职位") {
			item.Value = logInfo.PositionName;
		} else if (item.Property.Title[0].Text == "申请时间") {
			let date = new Date();
			date = DateFormat(date);
			item.Value = date;
		} else if (item.Property.Title[0].Text == "端口费用承担部门") {
			item.Value = logInfo.DeptName;
		}

	});
	return controls;
}
function DateFormat(date){
	return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
}
export async function assignControlBySpNo(controls, spNo, flowId,isLast) {
	if (spNo == null || spNo == undefined || spNo.length <= 0) {
		if (flowId == null || flowId == undefined || flowId.length <= 0) {
			return controls;
		}
		if(isLast){
			await getLastFlowTemplate(flowId).then(res => {
				var detailControls = res.Body;
				controls.TemplateContent.Controls.forEach(item => {
					// if(item.Property.Control=="Contact"){
					// 	return;
					// }
					var valueControl = detailControls.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text == item.Property.Title[0].Text
					});
					if (valueControl != null && valueControl.length > 0) {
						item.Value = valueControl[0].Value;
						item.Values = valueControl[0].Values;
					}
					if(item.Property.Control == "File"){
						if(valueControl[0]!=null&&valueControl[0].Values!=null&&valueControl[0].Values.length>0){
							if(item.Values != null){
								this.$set(item,'fileNames',[])
								console.log("item dddd")
								console.log(item)
								item.Values.forEach(data => {
									getMediaId(data[0]).then(res => {
										if (res.MediaId != null || res.ErrCode !== 4){
											data[0] = res.MediaId;
											item.fileNames.push({
												"key": res.fileName,
												"val": res.MediaId
											});
										}else{
											console.log("clear")
											this.$set(item,'fileNames',[])
											this.$set(item,'Values',null)
										}
									}).catch(err => {
										console.log("clear")
										this.$set(item,'fileNames',[])
										this.$set(item,'Values',null)
									});
								});
							}
						}
					}
					if (item.Property.Control == "Table") {
						var tableControl = detailControls.TemplateContent.Controls.filter(t => {
							return t.Property.Title[0].Text == item.Property.Title[0].Text
						});
						if (tableControl != null && tableControl.length > 0) {
							item.Config.Table.Children.forEach(childItem => {
								var valueControl = tableControl[0].Config.Table.Children.filter(t => {
									return t.Property.Title[0].Text == childItem.Property.Title[0].Text
								});
								if (valueControl != null && valueControl.length > 0) {
									if(valueControl[0].Property.Control == "Date"){
										if(valueControl[0].Value == "0001-01-01"){
											valueControl[0].Value = "";
										}else{
											childItem.Value = valueControl[0].Value;
											childItem.Values = valueControl[0].Values;
										}
									}else{
										childItem.Value = valueControl[0].Value;
										childItem.Values = valueControl[0].Values;
									}
									
									if (childItem.Property.Control == "Selector") {
										var selectText = "";
									
										if (childItem.Config.Selector.Type == "single") {
											var option = valueControl[0].Config.Selector.Options.filter(t => {
												return t.Key == childItem.Value
											});
											if (option != null && option.length > 0) {
												selectText = option[0].Value[0].Text
											}
											if (selectText != "") {
												var option = childItem.Config.Selector.Options.filter(t => {
													return t.Value[0].Text == selectText
												});
												if (option != null && option.length > 0) {
													childItem.Value = option[0].Key
												}
											}
										}
										if (childItem.Config.Selector.Type == "multi") {
											var values = [];
											childItem.Values.forEach(childValue => {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childValue
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														values.push(option[0].Key);
													}
												}
											});
											this.$set(childItem,'ValuesSelect',values)
										}
									}
								}
								
							})
						}
					}
					if (item.Property.Control == "Selector") {
						var selectText = "";
						
						if (item.Config.Selector.Type == "single") {
							
							var selectControl = detailControls.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == item.Property.Title[0].Text
							});
							
							if(selectControl!=null&&selectControl.length>0){
								var option = selectControl[0].Config.Selector.Options.filter(t => {
									return t.Key == selectControl[0].Value
								});
								if (option != null && option.length > 0) {
									selectText = option[0].Value[0].Text
								}
								if (selectControl != null && selectControl.length > 0 && selectText != "") {
									var option = item.Config.Selector.Options.filter(t => {
										return t.Value[0].Text == selectText
									});
									if (option != null && option.length > 0) {
										item.Value = option[0].Key
									}
								}
							}
						}
						if (item.Config.Selector.Type == "multi") {
							var values = [];
							item.Values.forEach(childValue => {
								var option = valueControl[0].Config.Selector.Options.filter(t => {
									return t.Key == childValue[0]
								});
								if (option != null && option.length > 0) {
									selectText = option[0].Value[0].Text
								}
								if (selectText != "") {
									var option = item.Config.Selector.Options.filter(t => {
										return t.Value[0].Text == selectText
									});
									if (option != null && option.length > 0) {
										values.push(option[0].Key);
									}
								}
							});
							if(values.length>0){
								// childItem.ValuesSelect = values;
								this.$set(item,'ValuesSelect',values)
							}
						}
					} 
				});
				for(var i = controls.TemplateContent.Controls.length-1;i>-1;i--){
					var item = controls.TemplateContent.Controls[i];
					if (item.Property.Control == "Table") {
						var tableControls = detailControls.TemplateContent.Controls.filter(t => {
							return t.Property.Title[0].Text.indexOf(item.Property.Title[0].Text)>-1
						});
						if (tableControls != null && tableControls.length > 0) {
							tableControls.forEach((tableControl,index) =>{
								if(item.Property.Title[0].Text == tableControl.Property.Title[0].Text){
									item.IsShow = true;
									item.addIsShow = false;
									item.Config.Table.Children.forEach(childItem => {
										var valueControl = tableControl.Config.Table.Children.filter(t => {
											return t.Property.Title[0].Text == childItem.Property.Title[0].Text
										});
										if (valueControl != null && valueControl.length > 0) {
											childItem.Value = valueControl[0].Value;
											childItem.Values = valueControl[0].Values;
										}
										
										if (childItem.Property.Control == "Selector") {
											var selectText = "";
											if (childItem.Config.Selector.Type == "single") {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childItem.Value
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														childItem.Value = option[0].Key
													}
												}
											}
											if (childItem.Config.Selector.Type == "multi") {
												var values = [];
												childItem.Values.forEach(childValue => {
													var option = valueControl[0].Config.Selector.Options.filter(t => {
														return t.Key == childValue[0]
													});
													if (option != null && option.length > 0) {
														selectText = option[0].Value[0].Text
													}
													if (selectText != "") {
														var option = childItem.Config.Selector.Options.filter(t => {
															return t.Value[0].Text == selectText
														});
														if (option != null && option.length > 0) {
															values.push(option[0].Key);
														}
													}
												});
												if(values.length>0){
													// childItem.ValuesSelect = values;
													this.$set(childItem,'ValuesSelect',values)
												}
											}
										}
									})
								}else{
									let dataString = JSON.stringify(item);
									let data = JSON.parse(dataString);
									data.IsShow = true;
									data.addIsShow = false;
									data.Property.Title[0].Text = data.Property.Title[0].Text+index;
									data.Config.Table.Children.forEach(childItem => {
										var valueControl = tableControl.Config.Table.Children.filter(t => {
											return t.Property.Title[0].Text == childItem.Property.Title[0].Text
										});
										if (valueControl != null && valueControl.length > 0) {
											childItem.Value = valueControl[0].Value;
											childItem.Values = valueControl[0].Values;
										}
										if (childItem.Property.Control == "Selector") {
											var selectText = "";
											if (childItem.Config.Selector.Type == "single") {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childItem.Value
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														childItem.Value = option[0].Key
													}
												}
											}
											if (childItem.Config.Selector.Type == "multi") {
												var values = [];
												childItem.Values.forEach(childValue => {
													var option = valueControl[0].Config.Selector.Options.filter(t => {
														return t.Key == childValue[0]
													});
													if (option != null && option.length > 0) {
														selectText = option[0].Value[0].Text
													}
													if (selectText != "") {
														var option = childItem.Config.Selector.Options.filter(t => {
															return t.Value[0].Text == selectText
														});
														if (option != null && option.length > 0) {
															values.push(option[0].Key);
														}
													}
												});
												if(values.length>0){
													// childItem.ValuesSelect = values;
													this.$set(childItem,'ValuesSelect',values)
												}
											}
										}
									})
									controls.TemplateContent.Controls.splice(i+index,0,data);
								}
							})
							
						}
					} 
				}
			})
		}else {
			await getFlowTemplate(flowId).then(res => {
				var detailControls = res.Body;
				controls.TemplateContent.Controls.forEach(item => {
					// if(item.Property.Control=="Contact"){
					// 	return;
					// }
					var valueControl = detailControls.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text == item.Property.Title[0].Text
					});
					if (valueControl != null && valueControl.length > 0) {
						item.Value = valueControl[0].Value;
						item.Values = valueControl[0].Values;
					}
					if(item.Property.Control == "File"){
						if(valueControl[0]!=null&&valueControl[0].Values!=null&&valueControl[0].Values.length>0){
							if(item.Values != null){
								this.$set(item,'fileNames',[])
								item.Values.forEach(data => {
									getMediaId(data[0]).then(res => {
										data[0] = res.MediaId;
										item.fileNames.push({
											"key": res.fileName,
											"val": res.MediaId
										});
									});
								});
							}
						}
					}
					if(item.Property.Control == "Date"){
						let time = new Date(parseInt(valueControl[0].Value) * 1000); 
						let y = time.getFullYear();
						let m = time.getMonth()+1;
						let d = time.getDate();
						if(d<10){
							d='0'+d;
						}
						item.Value = y+"-"+m+"-"+d; 
					}
					if (item.Property.Control == "Table") {
						var tableControl = detailControls.TemplateContent.Controls.filter(t => {
							return t.Property.Title[0].Text == item.Property.Title[0].Text
						});
						if (tableControl != null && tableControl.length > 0) {
							item.Config.Table.Children.forEach(childItem => {
								var valueControl = tableControl[0].Config.Table.Children.filter(t => {
									return t.Property.Title[0].Text == childItem.Property.Title[0].Text
								});
								if (valueControl != null && valueControl.length > 0) {
									if(valueControl[0].Property.Control == "Date"){
										if(valueControl[0].Value == "0001-01-01"){
											valueControl[0].Value = "";
										}else{
											childItem.Value = valueControl[0].Value;
											childItem.Values = valueControl[0].Values;
										}
									}else{
										childItem.Value = valueControl[0].Value;
										childItem.Values = valueControl[0].Values;
									}
									
									if (childItem.Property.Control == "Selector") {
										var selectText = "";
									
										if (childItem.Config.Selector.Type == "single") {
											var option = valueControl[0].Config.Selector.Options.filter(t => {
												return t.Key == childItem.Value
											});
											if (option != null && option.length > 0) {
												selectText = option[0].Value[0].Text
											}
											if (selectText != "") {
												var option = childItem.Config.Selector.Options.filter(t => {
													return t.Value[0].Text == selectText
												});
												if (option != null && option.length > 0) {
													childItem.Value = option[0].Key
												}
											}
										}
										if (childItem.Config.Selector.Type == "multi") {
											var values = [];
											childItem.Values.forEach(childValue => {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childValue
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														values.push(option[0].Key);
													}
												}
											});
											this.$set(childItem,'ValuesSelect',values)
										}
									}
								}
								
							})
						}
					}
					if (item.Property.Control == "Selector") {
						var selectText = "";
						
						if (item.Config.Selector.Type == "single") {
							
							var selectControl = detailControls.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == item.Property.Title[0].Text
							});
							
							if(selectControl!=null&&selectControl.length>0){
								var option = selectControl[0].Config.Selector.Options.filter(t => {
									return t.Key == selectControl[0].Value
								});
								if (option != null && option.length > 0) {
									selectText = option[0].Value[0].Text
								}
								if (selectControl != null && selectControl.length > 0 && selectText != "") {
									var option = item.Config.Selector.Options.filter(t => {
										return t.Value[0].Text == selectText
									});
									if (option != null && option.length > 0) {
										item.Value = option[0].Key
									}
								}
							}
						}
						if (item.Config.Selector.Type == "multi") {
							var values = [];
							item.Values.forEach(childValue => {
								var option = valueControl[0].Config.Selector.Options.filter(t => {
									return t.Key == childValue[0]
								});
								if (option != null && option.length > 0) {
									selectText = option[0].Value[0].Text
								}
								if (selectText != "") {
									var option = item.Config.Selector.Options.filter(t => {
										return t.Value[0].Text == selectText
									});
									if (option != null && option.length > 0) {
										values.push(option[0].Key);
									}
								}
							});
							if(values.length>0){
								// childItem.ValuesSelect = values;
								this.$set(item,'ValuesSelect',values)
							}
						}
					} 
				});
				for(var i = controls.TemplateContent.Controls.length-1;i>-1;i--){
					var item = controls.TemplateContent.Controls[i];
					if (item.Property.Control == "Table") {
						var tableControls = detailControls.TemplateContent.Controls.filter(t => {
							return t.Property.Title[0].Text.indexOf(item.Property.Title[0].Text)>-1
						});
						if (tableControls != null && tableControls.length > 0) {
							tableControls.forEach((tableControl,index) =>{
								if(item.Property.Title[0].Text == tableControl.Property.Title[0].Text){
									item.IsShow = true;
									item.addIsShow = false;
									item.Config.Table.Children.forEach(childItem => {
										var valueControl = tableControl.Config.Table.Children.filter(t => {
											return t.Property.Title[0].Text == childItem.Property.Title[0].Text
										});
										if (valueControl != null && valueControl.length > 0) {
											childItem.Value = valueControl[0].Value;
											childItem.Values = valueControl[0].Values;
										}
										if (childItem.Property.Control == "Selector") {
											var selectText = "";
											if (childItem.Config.Selector.Type == "single") {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childItem.Value
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														childItem.Value = option[0].Key
													}
												}
											}
											if (childItem.Config.Selector.Type == "multi") {
												var values = [];
												childItem.Values.forEach(childValue => {
													var option = valueControl[0].Config.Selector.Options.filter(t => {
														return t.Key == childValue[0]
													});
													if (option != null && option.length > 0) {
														selectText = option[0].Value[0].Text
													}
													if (selectText != "") {
														var option = childItem.Config.Selector.Options.filter(t => {
															return t.Value[0].Text == selectText
														});
														if (option != null && option.length > 0) {
															values.push(option[0].Key);
														}
													}
												});
												if(values.length>0){
													// childItem.ValuesSelect = values;
													this.$set(childItem,'ValuesSelect',values)
												}
											}
										}
									})
								}else{
									let dataString = JSON.stringify(item);
									let data = JSON.parse(dataString);
									data.IsShow = true;
									data.addIsShow = false;
									data.Property.Title[0].Text = data.Property.Title[0].Text+index;
									data.Config.Table.Children.forEach(childItem => {
										var valueControl = tableControl.Config.Table.Children.filter(t => {
											return t.Property.Title[0].Text == childItem.Property.Title[0].Text
										});
										if (valueControl != null && valueControl.length > 0) {
											childItem.Value = valueControl[0].Value;
											childItem.Values = valueControl[0].Values;
										}
										if (childItem.Property.Control == "Selector") {
											var selectText = "";
											if (childItem.Config.Selector.Type == "single") {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childItem.Value
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														childItem.Value = option[0].Key
													}
												}
											}
											if (childItem.Config.Selector.Type == "multi") {
												var values = [];
												childItem.Values.forEach(childValue => {
													var option = valueControl[0].Config.Selector.Options.filter(t => {
														return t.Key == childValue[0]
													});
													if (option != null && option.length > 0) {
														selectText = option[0].Value[0].Text
													}
													if (selectText != "") {
														var option = childItem.Config.Selector.Options.filter(t => {
															return t.Value[0].Text == selectText
														});
														if (option != null && option.length > 0) {
															values.push(option[0].Key);
														}
													}
												});
												if(values.length>0){
													// childItem.ValuesSelect = values;
													this.$set(childItem,'ValuesSelect',values)
												}
											}
										}
									})
									controls.TemplateContent.Controls.splice(i+index,0,data);
								}
							})
							
						}
					} 
				}
			})
		}
	} else {
		await getApproverDetailInfo(spNo).then(res => {
			var detailControls = res.Body;
			controls.TemplateContent.Controls.forEach(item => {
				var valueControl = detailControls.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == item.Property.Title[0].Text
				});
				if(valueControl!=null&&valueControl.length>0){
					if (valueControl != null && valueControl.length > 0) {
						if(valueControl[0].Property.Control == "Selector"&&valueControl[0].Config.Selector.Type == "single"){
							var val = "";
							item.Value = item.Config.Selector.Options.forEach(async (t) => {
								if(t.Value[0]!=null&& valueControl[0].Config.Selector.Options.length>0&&(t.Value[0].Text == valueControl[0].Config.Selector.Options[0].Value[0].Text)){
									 val= t.Key;
								}
							})
							item.Value = val;
						}else{
							if(valueControl[0].Property.Title[0].Text != "财务报销提示"){
								item.Value = valueControl[0].Value;
								item.Values = valueControl[0].Values;
							}
						}
					}
					if(item.Property.Control == "File"){
						if(valueControl[0]!=null&&valueControl[0].Values!=null&&valueControl[0].Values.length>0){
							if(item.Values != null){
								this.$set(item,'fileNames',[])
								item.Values.forEach(data => {
									getMediaId(data[0]).then(res => {
										data[0] = res.MediaId;
										item.fileNames.push({
											"key": res.fileName,
											"val": res.MediaId
										});
									});
								});
							}
						}
					}
					if(item.Property.Control == "Date"){
						let time = new Date(parseInt(valueControl[0].Value) * 1000); 
						let y = time.getFullYear();
						let m = time.getMonth()+1;
						let d = time.getDate();
						if(d<10){
							d='0'+d;
						}
						item.Value = y+"-"+m+"-"+d; 
					}
					if (item.Property.Control == "Table") {
						
						var tableControl = detailControls.TemplateContent.Controls.filter(t => {
							return t.Property.Title[0].Text == item.Property.Title[0].Text
						});
						if (tableControl != null && tableControl.length > 0) {
							item.IsShow = true;
							item.Config.Table.Children.forEach(childItem => {
								
								var valueControl = tableControl[0].Config.Table.Children.filter(t => {
									return t.Property.Title[0].Text == childItem.Property.Title[0].Text
								});
								if (valueControl != null && valueControl.length > 0) {
									childItem.Value = valueControl[0].Value;
									childItem.Values = valueControl[0].Values;
								}
								if(childItem.Property.Control == "Date"){
									let time = new Date(parseInt(valueControl[0].Value) * 1000); 
									let y = time.getFullYear();
									let m = time.getMonth()+1;
									let d = time.getDate();
									if(d<10){
										d='0'+d;
									}
									let dateValue = y+"-"+m+"-"+d
									this.$set(childItem,'Value',dateValue)
									
								}
								if (childItem.Property.Control == "Selector") {
									if (childItem.Config.Selector.Type == "single") {
										var option = valueControl[0].Config.Selector.Options.filter(t => {
											return t.Key == childItem.Value
										});
										if (option != null && option.length > 0) {
											selectText = option[0].Value[0].Text
										}
										if (selectText != "") {
											var option = childItem.Config.Selector.Options.filter(t => {
												return t.Value[0].Text == selectText
											});
											if (option != null && option.length > 0) {
												childItem.Value = option[0].Key
											}
										}
									}
									if (childItem.Config.Selector.Type == "multi") {
										var values = [];
										childItem.Values.forEach(childValue => {
											var option = valueControl[0].Config.Selector.Options.filter(t => {
												return t.Key == childValue[0]
											});
											if (option != null && option.length > 0) {
												selectText = option[0].Value[0].Text
											}
											if (selectText != "") {
												var option = childItem.Config.Selector.Options.filter(t => {
													return t.Value[0].Text == selectText
												});
												if (option != null && option.length > 0) {
													values.push(option[0].Key);
												}
											}
										});
										if(values.length>0){
											// childItem.ValuesSelect = values;
											this.$set(childItem,'ValuesSelect',values)
										}
									}
								}
							})
						}
					} 
					else  if (item.Property.Control == "Selector") {
						if(item.Config != null){
								// if (item.Config.Selector.Type == "single") {
								// 	var option = item.Config.Selector.Options.filter(t => {
								// 		if(t.Key == item.Value){
								// 			return t;
								// 		}
								// 	});
								// 	console.log(option);
								// 	if (option != null && option.length > 0) {
								// 		selectText = option[0].Value[0].Text
								// 	}
								// 	var selectControl = detailControls.TemplateContent.Controls.filter(t => {
								// 		return t.Property.Title[0].Text == item.Property.Title[0].Text
								// 	});
								// 	if (selectControl != null && selectControl.length > 0 && selectText != "") {
								// 		var option = selectControl[0].Config.Selector.Options.filter(t => {
								// 			return t.Value[0].Text == selectText
								// 		});
								// 		if (option != null && option.length > 0) {
								// 			item.Value = option[0].Key
								// 		}
								// 	}
								// }
								
								if (item.Config.Selector.Type == "multi") {
									var selectText = "";
									var values = [];
									item.Values.forEach(childValue => {
										var option = valueControl[0].Config.Selector.Options.filter(t => {
											return t.Key == childValue
										});
										if (option != null && option.length > 0) {
											selectText = option[0].Value[0].Text
										}
										if (selectText != "") {
											var option = item.Config.Selector.Options.filter(t => {
												return t.Value[0].Text == selectText
											});
											if (option != null && option.length > 0) {
												values.push(option[0].Key);
											}
										}
									});
									this.$set(item,'ValuesSelect',values)
								}
							}
						} else {
							if (item.Property.Title[0].Text == "申请人员部门") {
								var select = detailControls.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == "申请人员部门"
								})[0];
								var text = select.Config.Selector.Options.filter(t => {
									return t.Key == select.Value
								})[0].Value[0].Text
								item.Value = item.Config.Selector.Options.filter(e => {
									return e.Value[0].Text == text
								})[0].Key
							} 
						
						}
				}
				
					
			});
			for(var i = controls.TemplateContent.Controls.length-1;i>-1;i--){
				var item = controls.TemplateContent.Controls[i];
				if (item.Property.Control == "Table") {
					var tableControls = detailControls.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text.indexOf(item.Property.Title[0].Text)>-1
					});
					if (tableControls != null && tableControls.length > 0) {
						tableControls.forEach((tableControl,index) =>{
							if(item.Property.Title[0].Text == tableControl.Property.Title[0].Text){
								item.IsShow = true;
								item.addIsShow = false;
								item.Config.Table.Children.forEach(childItem => {
									var valueControl = tableControl.Config.Table.Children.filter(t => {
										return t.Property.Title[0].Text == childItem.Property.Title[0].Text
									});
									if (valueControl != null && valueControl.length > 0) {
										childItem.Value = valueControl[0].Value;
										childItem.Values = valueControl[0].Values;
									}
									if(childItem.Property.Control == "Date"){
										let time = new Date(parseInt(valueControl[0].Value) * 1000); 
										let y = time.getFullYear();
										let m = time.getMonth()+1;
										let d = time.getDate();
										if(d<10){
											d='0'+d;
										}
										let dateValue = y+"-"+m+"-"+d
										this.$set(childItem,'Value',dateValue)
									}
									if (childItem.Property.Control == "Selector") {
										var selectText = "";
										if (childItem.Config.Selector.Type == "single") {
											var option = valueControl[0].Config.Selector.Options.filter(t => {
												return t.Key == childItem.Value
											});
											if (option != null && option.length > 0) {
												selectText = option[0].Value[0].Text
											}
											if (selectText != "") {
												var option = childItem.Config.Selector.Options.filter(t => {
													return t.Value[0].Text == selectText
												});
												if (option != null && option.length > 0) {
													childItem.Value = option[0].Key
												}
											}
										}
										if (childItem.Config.Selector.Type == "multi") {
											var values = [];
											childItem.Values.forEach(childValue => {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childValue[0]
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														values.push(option[0].Key);
													}
												}
											});
											if(values.length>0){
												// childItem.ValuesSelect = values;
												this.$set(childItem,'ValuesSelect',values)
											}
										}
									}
								})
							}else{
								let dataString = JSON.stringify(item);
								let data = JSON.parse(dataString);
								data.IsShow = true;
								data.addIsShow = false;
								data.Property.Title[0].Text = data.Property.Title[0].Text+index;
								data.Config.Table.Children.forEach(childItem => {
									var valueControl = tableControl.Config.Table.Children.filter(t => {
										return t.Property.Title[0].Text == childItem.Property.Title[0].Text
									});
									if (valueControl != null && valueControl.length > 0) {
										childItem.Value = valueControl[0].Value;
										childItem.Values = valueControl[0].Values;
									}
									if (childItem.Property.Control == "Selector") {
										var selectText = "";
										if (childItem.Config.Selector.Type == "single") {
											var option = valueControl[0].Config.Selector.Options.filter(t => {
												return t.Key == childItem.Value
											});
											if (option != null && option.length > 0) {
												selectText = option[0].Value[0].Text
											}
											if (selectText != "") {
												var option = childItem.Config.Selector.Options.filter(t => {
													return t.Value[0].Text == selectText
												});
												if (option != null && option.length > 0) {
													childItem.Value = option[0].Key
												}
											}
										}
										if (childItem.Config.Selector.Type == "multi") {
											var values = [];
											childItem.Values.forEach(childValue => {
												var option = valueControl[0].Config.Selector.Options.filter(t => {
													return t.Key == childValue[0]
												});
												if (option != null && option.length > 0) {
													selectText = option[0].Value[0].Text
												}
												if (selectText != "") {
													var option = childItem.Config.Selector.Options.filter(t => {
														return t.Value[0].Text == selectText
													});
													if (option != null && option.length > 0) {
														values.push(option[0].Key);
													}
												}
											});
											if(values.length>0){
												// childItem.ValuesSelect = values;
												this.$set(childItem,'ValuesSelect',values)
											}
										}
									}
								})
								controls.TemplateContent.Controls.splice(i+index,0,data);
							}
						})
						
					}
				} 
			}
			
		});
	}
	return controls;
}

//提交校验
export function submitValidate(controls) {
	var isSuccess = true;
	for (let i in controls) {
		var item = controls[i];
		if (!isSuccess) {
			break;
		}
		//必填项校验
		if(item.Value !=null){
			item.Value += "";
			item.Value = item.Value.trim();
		}
		if (item.Property != null &&
			item.Property.Control != "Table"&&
			item.Property.Require == 1 &&
			((item.Value == null || item.Value.length <= 0) && (item.Values == null || item.Values.length <= 0))) {
			Message.closeAll();
			Message({
				message: item.Property.Title[0].Text + "未填写,请填写完整",
				type: 'error',
				duration: 3 * 1000
			});
			
			isSuccess = false;
			break;
		}
		
		if (item.Property.Title[0].Text == "流程条件") {
			item.Value = item.Value.toString();
			if (item.Value < 0) {
				Message.closeAll();
				Message({
					message: '没有申请权限',
					type: 'error',
					duration: 1000
				});
				isSuccess = false;
				break;
			}
		}

		//Table校验
		if (item.Property.Control == "Table") {
			for (let k in item.Config.Table.Children) {
				var childItem = item.Config.Table.Children[k];
				if(childItem.Value!=null){
					childItem.Value += "";
					childItem.Value = childItem.Value.trim();
				}
				if (childItem.Property.Require == 1 && ((childItem.Value == null || childItem.Value == '') &&
						(childItem.Values == '' || childItem.Values == null))) {
					Message({
						message: childItem.Property.Title[0].Text + "未填写,请填写完整",
						type: 'error',
						duration: 3 * 1000
					});
					isSuccess = false;
					break;
				}
				
				
			}
		}
	}
	return isSuccess;
}

// 表格数据转表单数据
export function convertInTable(data, tableModel) {
	var tableDatas = [];
	for (var i = 0; i < data.length; i++) {
		var tableData = JSON.parse(JSON.stringify(tableModel));
		for (var j = 0; j < tableData.Config.Table.Children.length; j++) {
			for (var k = 0; k < data[i].length; k++) {
				if (data[i][k].text == tableData.Config.Table.Children[j].Property.Title[0].Text) {
					if(data[i][k].val!=null){
						tableData.Config.Table.Children[j].Value = data[i][k].val.toString();
					}else{
						tableData.Config.Table.Children[j].Value=null;
					}
				}
			}
		}
		tableData.Property.Title[0].Text = i == 0 ? tableData.Property.Title[0].Text : tableData.Property.Title[0].Text + i;
		tableData.Property.Control = "Table";
		tableDatas.push(tableData);
	}
	tableDatas.IsShow = false;
	return tableDatas;
}
